<script>
export default {
  data() {
    return {
      locale: this.$i18n.locale ? this.$i18n.locale : 'ru',
      options: [
        {value: 'ru', text: 'Русский'},
        {value: 'en', text: 'English'}
      ]
    }
  },
  mounted() {
    // console.log(this.locale);
  },
  watch: {
    locale(val) {
      if (['ru', 'en'].includes(val)) {
        this.$i18n.locale = val
        localStorage.setItem('lang', val)
      }
    }
  },
  methods: {}
}
</script>

<template>
  <!-- Footer Start -->
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <p style="line-height: 35px">2020 &copy; Vikingo</p>
        </div>
        <div class="col-md-4">
          <div
            class="text-md-right footer-links d-none d-sm-block"
            style="line-height: 35px"
          >
            <a href="javascript:void(0);">About Us</a>
            <a href="javascript:void(0);">FAQ</a>
          </div>
        </div>
        <div class="col-md-2">
          <div class="text-md-right footer-links d-none d-sm-block">
            <b-form-select v-model="locale" :options="options"></b-form-select>
          </div>
        </div>
      </div>
    </div>
  </footer>
  <!-- end Footer -->
</template>

<style scoped>
.footer {
  padding: 10px 0px 0px;
}
</style>
